import * as React from 'react'

interface TabsProps {
  defaultTab?: number
  children?: React.ReactNode | undefined
}

interface TabState {
  activeTab: number
}

interface TabProps {
  onClick?: (event: any) => void
  tabName: string
  tabIndex?: number
  isActive?: boolean
}

class ModalTabs extends React.Component<TabsProps, TabState> {
  constructor(props: TabsProps) {
    super(props)
    this.state = {
      activeTab: props.defaultTab ? props.defaultTab : 0,
    }
    this.handleTabClick = this.handleTabClick.bind(this)
  }

  public getDefaultTab(): number {
    return this.props.defaultTab ? this.props.defaultTab : 0
  }

  public handleTabClick(index: number) {
    this.setState({
      activeTab: index === this.state.activeTab ? this.getDefaultTab() : index,
    })
  }

  // Encapsulate <Tabs/> component API as props for <Tab /> children
  public renderChildrenWithTabsApiAsProps() {
    return React.Children.map(this.props.children, (child, index) => {
      const childElement = child as React.ReactElement<any>
      return React.cloneElement(childElement, {
        onClick: this.handleTabClick,
        tabIndex: index,
        isActive: index === this.state.activeTab,
      })
    })
  }

  // Render current active tab content
  public renderActiveTabContent() {
    const { children } = this.props
    const { activeTab } = this.state
    if (children && (children as any)[activeTab]) {
      return (children as any)[activeTab].props.children
    }
  }

  public render() {
    return (
      <div className="srprs-tabs">
        <ul className="srprs-modalTabs">
          {this.renderChildrenWithTabsApiAsProps()}
        </ul>
        <div className="content">{this.renderActiveTabContent()}</div>
      </div>
    )
  }
}

const ModalTab: React.FC<TabProps> = props => {
  return (
    <li className={`${props.isActive ? 'is-current' : ''}`} id={props.tabName}>
      <a
        href="javascript:void(0)"
        onClick={event => {
          event.preventDefault()
          if (props.onClick) {
            props.onClick(props.tabIndex)
          }
        }}
      >
        {props.tabName}
      </a>
    </li>
  )
}

export { ModalTabs, ModalTab }
